<div
    class="agpr-profileSection"
>
    <agpr-panel
        [header]="profileSection?.heading"
        [toggleable]='false'
        [marginTop]="0"
        [paddingBottom]="0"
    >
        <ng-container  *ngFor="let item of profileSection?.items; last as last">
            <div class="agpr-profileSection-item"  [ngClass]="{'agpr-profileSection-item--last': last }">
                <div class="agpr-profileSection-item-heading">
                    {{ item.heading | localize }}
                </div>
                <ng-container *ngIf="arrayClass.isArray(item.content) else singleValue">
                    <dl *ngFor="let contentGroup of item.content">
                        <dt class="agpr-profileSection-item-subheading">
                            {{ contentGroup.header | localize }}
                        </dt>
                        <dd
                            *ngFor="let contentItem of contentGroup.content"
                            class="agpr-profileSection-item-content"
                        >
                            {{ contentItem | localize }}
                        </dd>
                    </dl>
                </ng-container>
                <ng-template #singleValue>
                    <div class="agpr-profileSection-item-content">
                        {{ item.content | localize }}
                    </div>
                </ng-template>
            </div>
        </ng-container>
    </agpr-panel>
</div>